import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react'

export const LootboxMarketModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal size={'md'} isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalHeader pb={2} fontSize="xl" fontWeight="700"></ModalHeader>
        <ModalCloseButton onClick={onClose} size="sm" />
        <ModalBody pb={5}>
          <LootboxMarket />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const LootboxMarket = () => {
  return null
}
